





























import SelectControl from "@share/common/controls/select/SelectControl.vue";
import { DropDownItem } from "@share/common/drop-down/types";
import TagList from "@share/common/tag-list/TagList.vue";
import TagItem from "@share/common/tag/TagItem.vue";
import { Component, Prop, Mixins } from "vue-property-decorator";
import { BaseBorderless } from "@share/common/form/form-controls/base/borderless/base-borderless";
import { StubInputBase } from "@share/common/form/form-controls/stub/stub-input-base";


@Component({
    components: { SelectControl, TagList, TagItem }
})

export default class SingleSelect extends Mixins(StubInputBase, BaseBorderless) {

    @Prop({ default: (() => []) }) declare value: DropDownItem | null;
    @Prop({ default: (() => [])}) source: DropDownItem[];
    @Prop() side: 'top' | 'bottom' | undefined;

    keyword = "";

    search(keyword: string) {
        this.keyword = keyword;
        this.$emit('search', keyword)
    }

    get useSearch() {
        return !!this.$listeners['search'];
    }

    get title() {
        return this.value?.title
    }
}

